import PricingCard from "../../components/pricingCard";
import pattern from "../../assets/images/bluePattern.svg";
import { useNavigate } from "react-router-dom";
import RAM from "../../assets/svg-icons/blueRAM.svg";
import disk from "../../assets/svg-icons/smallDisk.svg";
import cpu from "../../assets/svg-icons/smallBlueCPU.svg";
import useReveal from "../../hooks/useReveal";

const Pricing = () => {
  document.title = "Pricing - Cloudvantage";

  const navigate = useNavigate();

  const [heroRef, heroVisible] = useReveal();
  const [gridRef, gridVisible] = useReveal();
  const saveVpsActionOnAuthClick = () => {
    navigate("/sign-in", { state: { actionType: "saveVpsActionOnAuthClick" } });
  };

  return (
    <div className="px-4 md:px-0 py-4 grid gap-6">
      {/* Hero Section */}
      <div ref={heroRef} className={`bg-brandBlue rounded-md grid grid-cols-1 lg:grid-cols-5 ${heroVisible ? 'animate-reveal' : 'opacity-0'}`}>
        <div className="lg:col-span-3 px-6 md:px-10 py-4 md:py-8">
          <p className="text-xl leading-snug crimson-font font-bold mb-4">
            Affordable plans for service
          </p>
          <ul className="list-disc pl-5 text-base text-black space-y-2">
            <li>Pay in your local currency</li>
            <li>Plan your budget with ease</li>
            <li>Know your costs ahead — no surprises</li>
            <li>Quick and easy payments</li>
            <li>Manage Your funds easily with wallet</li>
          </ul>
        </div>
        <div className="lg:col-span-2 flex items-end md:h-32 lg:h-full overflow-clip">
          <img src={pattern} alt="" className="w-full" />
        </div>
      </div>

      {/* Pricing Cards Grid */}
      <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 ${gridVisible ? 'animate-reveal' : 'opacity-0'}`}>
        <PricingCard
          category={"Virtual Private Servers (VPS)"}
          price={"13,500"}
          duration={"month"}
          dewType={"Vantage starter"}
          cpu={"1"}
          ram={"2 GB"}
          storage={"10 GB (NVMe)"}
          buttonText={"Get Started"}
          buttonColor={"#1DA1F2"}
          onClick={saveVpsActionOnAuthClick}
        />

        <PricingCard
          category={"Virtual Private Servers (VPS)"}
          price={"17,000"}
          duration={"month"}
          dewType={"Vantage nano"}
          cpu={"1"}
          ram={"1 GB"}
          storage={"30 GB (NVMe)"}
          buttonText={"Get Started"}
          buttonColor={"#1DA1F2"}
          onClick={saveVpsActionOnAuthClick}
        />

        <PricingCard
          category={"Virtual Private Servers (VPS)"}
          price={"24,500"}
          duration={"month"}
          dewType={"Vantage small"}
          cpu={"1"}
          ram={"2 GB"}
          storage={"50 GB (NVMe)"}
          buttonText={"Get Started"}
          buttonColor={"#1DA1F2"}
          onClick={saveVpsActionOnAuthClick}
        />

        <PricingCard
          category={"Virtual Private Servers (VPS)"}
          price={"28,600"}
          duration={"month"}
          dewType={"Vantage pivot"}
          cpu={"2"}
          ram={"2 GB"}
          storage={"50 GB (NVMe)"}
          buttonText={"Get Started"}
          buttonColor={"#1DA1F2"}
          onClick={saveVpsActionOnAuthClick}
        />

        <PricingCard
          category={"Virtual Private Servers (VPS)"}
          price={"37,400"}
          duration={"month"}
          dewType={"Vantage dev"}
          cpu={"2"}
          ram={"2 GB"}
          storage={"80 GB (NVMe)"}
          buttonText={"Get Started"}
          buttonColor={"#1DA1F2"}
          onClick={saveVpsActionOnAuthClick}
        />

        <PricingCard
          category={"Virtual Private Servers (VPS)"}
          price={"42,500"}
          duration={"month"}
          dewType={"Vantage basic"}
          cpu={"2"}
          ram={"4 GB"}
          storage={"80 GB (NVMe)"}
          buttonText={"Get Started"}
          buttonColor={"#1DA1F2"}
          onClick={saveVpsActionOnAuthClick}
        />

        <PricingCard
          category={"Virtual Private Servers (VPS)"}
          price={"48,500"}
          duration={"month"}
          dewType={"Vantage nub"}
          cpu={"2"}
          ram={"4 GB"}
          storage={"100 GB (NVMe)"}
          buttonText={"Get Started"}
          buttonColor={"#1DA1F2"}
          onClick={saveVpsActionOnAuthClick}
        />

        {/* Custom Plan Card */}
        <div className="bg-white rounded-md p-4 flex flex-col justify-between gap-6 h-full">
          <div className="flex flex-1 flex-col items-center justify-center text-center">
            <p className="text-sm leading-snug">
              Your Dew not listed? No problem. <br />
              Create yours with our <span className="font-bold">Customize</span> feature.
            </p>
            <div className="flex flex-row gap-2 mt-3">
              <img src={disk} alt="disk icon" />
              <img src={cpu} alt="cpu icon" />
              <img src={RAM} alt="ram icon" />
            </div>
          </div>
          <div className="w-full">
    <div
      onClick={saveVpsActionOnAuthClick}
      className="text-white text-xs px-6 py-4 rounded-sm text-center cursor-pointer"
      style={{ backgroundColor: "#1DA1F2" }}
    >
      Get Started
    </div>
  </div>
</div>
      </div>
    </div>
  );
}

export default Pricing;

